import axios from "axios";

import { getTokenData } from "../../../shared/utils/utils";

export async function CampaignById(campaignId) {
  try {
    const { token, client_id } = await getTokenData();

    if (!token) throw new Error("Token de autenticação não encontrado");
    if (!client_id) throw new Error("ID do cliente não encontrado");

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/campaigns/${campaignId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
          Client_ID: `${client_id}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar campanha por ID:", error);
    const errorMsg =
      error.response?.data?.message ||
      "Erro desconhecido ao buscar campanha";

    throw new Error(`Erro ao buscar campanha: ${errorMsg}`);
  }
}
